import { Backdrop, CircularProgress, Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import CheckIn from './CheckIn';
import List from './List';
import { getUser } from 'src/utils/Common';
import axios from '../../utils/axios';
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function Inventory() {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [inventory, setInventory] = useState([]);
  const user = getUser();
  useEffect(() => {
    setLoading(true);
    axios.get(`/SetWarehouseInventory/${user.ServiceShopId}/${user.OrganizationUserId}/${' '}/${0}`)
      .then(response => {
        response.data?.length === 0 ? setInventory([]) : setInventory(response.data);
        setLoading(false);
      })
  // eslint-disable-next-line
  }, []);


  const SendSetWarehouseInventory = (barcode, warehouse) => {
    setLoading(true);
    axios.get(`/SetWarehouseInventory/${user.ServiceShopId}/${user.OrganizationUserId}/${barcode}/${warehouse}`)
      .then(response => {
        response.data?.length === 0 ? setInventory([]) : setInventory(response.data);
        setLoading(false);
      })
  }

  const SendUpdateWarehouseInventory = (id, count) => {
    if(count === ''){
      count = 0;
    }
    setLoading(true);
    axios.get(`/UpdateWarehouseInventory/${id}/${user.OrganizationUserId}/${user.ServiceShopId}/${count}`)
      .then(response => {
        response.data?.length === 0 ? setInventory([]) : setInventory(response.data);
        setLoading(false);
      })
  }

  const updateNewCount = (id, newCount) => {

    if(newCount !== '' && isNaN(Number(newCount)))
      return;
    let oldInventory = [...inventory];
    let index = oldInventory.findIndex(x => x.id === id);
    oldInventory[index].newCount = newCount;
    setInventory(oldInventory);
  }

  return (
    <Page className={classes.root} title="Depo Sayım">
      <Container maxWidth="lg">
        {loading &&
          <Backdrop className={classes.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
        }
        <Header />
        <CheckIn SendSetWarehouseInventory={SendSetWarehouseInventory} />
        <List inventory={inventory} SendUpdateWarehouseInventory={SendUpdateWarehouseInventory} updateNewCount={updateNewCount} />
      </Container>
    </Page>
  );
}

export default Inventory;
